export const PREVIEW_LAYOUTS = {
  1: [
    { key: 'data_com_dia', label: 'Data', width: '12%', nowrap: true },
    { key: 'hora_reuniao', label: 'Hora', width: '8%' },
    { key: 'localidade', label: 'Localidade', width: '50%', },
    { key: 'presidencia', label: 'Ancião', width: '20%', icon: 'libras' },
  ],

  2: [
    { key: 'data_com_dia', label: 'Data', width: '14%', nowrap: true },
    { key: 'hora_reuniao', label: 'Hora' },
    { key: 'reuniao_composta', label: 'Reunião', multiline: true, icon: 'libras', width: '77%' },
  ],

  3: [
    { key: 'data_com_dia', label: 'Data', width: '12%', nowrap: true },
    { key: 'hora_reuniao', label: 'Hora' },
    { key: 'localidade', label: 'Localidade' },
    { key: 'presidencia_composta', label: 'Ancião e Enc.', multiline: true, width: '25%', icon: 'libras' },
  ],

  4: [
    { key: 'data_com_dia', label: 'Data', width: '12%', nowrap: true },
    { key: 'hora_reuniao', label: 'Hora', },
    { key: 'localidade_completa', label: 'Localidade' },
    { key: 'presidencia', label: 'Presidência', width: '25%' },
  ],

  5: [
    { key: 'data_com_dia', label: 'Data', width: '12%', nowrap: true },
    { key: 'hora_reuniao', label: 'Hora', },
    { key: 'localidade', label: 'Localidade' },
    { key: 'presidencia', label: 'Pres./Águas' },
    { key: 'presidencia_2', label: 'Presidência Trib.' },
    { key: 'presidencia_3', label: 'Oração' }
  ],

  6: [
    { key: 'data_com_dia', label: 'Data', width: '12%', nowrap: true },
    { key: 'hora_reuniao', label: 'Hora' },
    { key: 'localidade', label: 'Igreja' },
    { key: 'presidencia', label: 'Diácono-Tanque' },
    { key: 'presidencia_3', label: 'Diácono-Vestiário/Porta' }
  ],

  7: [
    { key: 'data_com_dia', label: 'Data', width: '12%', nowrap: true },
    { key: 'hora_reuniao', label: 'Hora' },
    { key: 'nome_reuniao', label: 'Setor' },
    { key: 'localidade', label: 'Igreja' },
    { key: 'presidencia', label: 'Diácono' }
  ]
};